import { render, staticRenderFns } from "./inspecttasklist.vue?vue&type=template&id=53f3e466&"
import script from "./inspecttasklist.vue?vue&type=script&lang=js&"
export * from "./inspecttasklist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports